var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { defaultTooltipDirection } from '../constants';
import { cx } from '@emotion/css';
import React from 'react';
import { IconInfo, IconInfoOutline } from '@axafr-btc-ds/icons';
import { TooltipMessage } from './tooltip-message';
import { TooltipIconSize } from '../tooltip.type';
import { useElementPosition } from '../hooks/useElementPosition';
import { getElementBounds } from '../bound';
import { tooltip, tooltipIcon } from './css';
var TIME_TO_NOT_AUTO_BLUR_ON_MOBILE = 200;
// eslint-disable-next-line max-lines-per-function
export var Tooltip = function (_a) {
    var className = _a.className, iconClassName = _a.iconClassName, messageClassName = _a.messageClassName, _b = _a.direction, direction = _b === void 0 ? defaultTooltipDirection : _b, _c = _a.containerBounds, containerBounds = _c === void 0 ? getElementBounds(document.body) : _c, _d = _a.iconSize, iconSize = _d === void 0 ? TooltipIconSize.M : _d, onClose = _a.onClose, onOpen = _a.onOpen, children = _a.children, props = __rest(_a, ["className", "iconClassName", "messageClassName", "direction", "containerBounds", "iconSize", "onClose", "onOpen", "children"]);
    var _e = useElementPosition(), tooltipBounds = _e.bounds, setRef = _e.setRef;
    var _f = React.useState(false), isOpen = _f[0], setIsOpen = _f[1];
    var _g = React.useState(false), blockOnBlur = _g[0], setBlockOnBlur = _g[1];
    var Icon = isOpen ? IconInfo : IconInfoOutline;
    var openTooltip = function (evt) {
        evt.stopPropagation();
        !isOpen && (onOpen === null || onOpen === void 0 ? void 0 : onOpen());
        setBlockOnBlur(true);
        var timerId = setTimeout(function () {
            isOpen && (onClose === null || onClose === void 0 ? void 0 : onClose());
            setBlockOnBlur(false);
            clearTimeout(timerId);
        }, TIME_TO_NOT_AUTO_BLUR_ON_MOBILE);
        setIsOpen(true);
    };
    var closeTooltip = function () {
        if (blockOnBlur)
            return;
        setIsOpen(false);
    };
    return (React.createElement("div", __assign({}, props, { className: cx(tooltip, className), tabIndex: 0, onFocus: openTooltip, onClick: openTooltip, onBlur: closeTooltip, onMouseEnter: openTooltip, onMouseLeave: closeTooltip }),
        React.createElement(Icon, { ref: setRef, className: tooltipIcon(iconSize), iconClassName: iconClassName }),
        React.createElement(TooltipMessage, { containerBounds: containerBounds, originBounds: tooltipBounds, className: messageClassName, isOpen: isOpen, content: children, direction: direction })));
};
